module.exports = __webpack_public_path__ + "media/src/assets/logo-7cdb7b44e1ba31847fbf1310944cec6e.png";